import { FC, useCallback } from 'react'
import { FormattedBookingTypeData } from '../../../models/property-details-page/booking-type-model'
import { GalleryFooterButton, GalleryFooterWrapper } from './styles'
import EnquiryButton from '../enquiry-button'
import BookNowButton from '../book-now-button'
import BindingInquiryButton from '../binding-inquiry-button'
import { SearchbarFieldsReturn, UpdateSearchBarTransport } from '../hooks/use-searchbar'
import isInquiryButtonVisible from '../side-bar/utils/is-inquiry-button-visible'
import isDirectBookingButtonVisible from '../side-bar/utils/is-direct-booking-button-visible'
import is24HourBookingButtonVisible from '../side-bar/utils/is-24-hour-booking-button-visible'
import CheckAvailabilityButton from '../check-availability'
import { FormattedLivePricingDataTransport } from '../../../models/pricing/live-pricing-formatter'
import InquiryContactDetailsTransport from '../../../transports/inquiry-contact-details-transport'
import UserDetailsModel from '../../../models/user/user-details-model'
import { PdpToCheckoutPosition } from '../constants'
import isCheckAvailabilityButtonVisible from '../side-bar/utils/is-check-availability-button-visible'
import { usePropertyDetailsContext } from '../../../hooks/property-details'

interface GalleryFooterProps {
    bookingType: FormattedBookingTypeData | null
    searchbar: SearchbarFieldsReturn
    pricingDetails: FormattedLivePricingDataTransport | null
    inquiryContactDetails: InquiryContactDetailsTransport | null
    isPricingLoading: boolean
    isAvailabilityLoading: boolean
    pricingErrorCode: number | null
    updateSearchbar: UpdateSearchBarTransport
    availableDates: Date[] | null
    userDetails: UserDetailsModel | null
    petsAllowed: boolean
    onClose: () => void
    onSelectDatesButtonClick: () => void
}

const GalleryFooter: FC<GalleryFooterProps> = ({
    bookingType,
    searchbar,
    onClose,
    onSelectDatesButtonClick,
    ...restProps
}) => {
    const onCheckAvailabilityClick = useCallback(() => {
        onClose()
        onSelectDatesButtonClick()
    }, [onClose, onSelectDatesButtonClick])

    const { isComboListing } = usePropertyDetailsContext()

    return (
        <GalleryFooterWrapper>
            {isCheckAvailabilityButtonVisible(isComboListing, bookingType, searchbar) ? (
                <CheckAvailabilityButton
                    onClick={onCheckAvailabilityClick}
                    position={PdpToCheckoutPosition.GALLERY_FOOTER}
                />
            ) : (
                <>
                    {isInquiryButtonVisible({ bookingType }) && (
                        <GalleryFooterButton>
                            <EnquiryButton
                                bookingType={bookingType}
                                searchbar={searchbar}
                                position={PdpToCheckoutPosition.GALLERY_FOOTER}
                                {...restProps}
                            />
                        </GalleryFooterButton>
                    )}
                    {isDirectBookingButtonVisible({ bookingType }) && (
                        <GalleryFooterButton>
                            <BookNowButton
                                bookingType={bookingType}
                                searchbar={searchbar}
                                position={PdpToCheckoutPosition.GALLERY_FOOTER}
                            />
                        </GalleryFooterButton>
                    )}
                    {is24HourBookingButtonVisible({ bookingType }) && (
                        <GalleryFooterButton>
                            <BindingInquiryButton
                                bookingType={bookingType}
                                searchbar={searchbar}
                                position={PdpToCheckoutPosition.GALLERY_FOOTER}
                            />
                        </GalleryFooterButton>
                    )}
                </>
            )}
        </GalleryFooterWrapper>
    )
}

export default GalleryFooter
